export { PartnerTimeline as default } from "./partner-timeline";
